const EVENTS = [
  { start: "20261125T193000Z", end: "20261125T213000Z", title: "Workshop Natural Anti-Age · Serata 1 – Il metodo e il viso", label: "Mercoledì 25 novembre" },
  { start: "20261126T193000Z", end: "20261126T213000Z", title: "Workshop Natural Anti-Age · Serata 2 – Il corpo e il tuo centro", label: "Giovedì 26 novembre" },
];
const DETAILS = "Workshop Natural Anti-Age Skin Lovers con Valentina e Renata. Il link Zoom arriva su WhatsApp dopo la verifica dell'iscrizione.";

export const googleLinks = () =>
  EVENTS.map((e) => ({
    label: e.label,
    url: `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(e.title)}&dates=${e.start}/${e.end}&details=${encodeURIComponent(DETAILS)}&location=Zoom`,
  }));

export function downloadIcs() {
  const stamp = new Date().toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
  const body = EVENTS.map(
    (e, i) => `BEGIN:VEVENT\r\nUID:skinlovers-workshop-${i + 1}@skinlovers\r\nDTSTAMP:${stamp}\r\nDTSTART:${e.start}\r\nDTEND:${e.end}\r\nSUMMARY:${e.title}\r\nDESCRIPTION:${DETAILS}\r\nLOCATION:Zoom\r\nBEGIN:VALARM\r\nTRIGGER:-PT1H\r\nACTION:DISPLAY\r\nDESCRIPTION:Promemoria workshop\r\nEND:VALARM\r\nEND:VEVENT`
  ).join("\r\n");
  const ics = `BEGIN:VCALENDAR\r\nVERSION:2.0\r\nPRODID:-//Skin Lovers//Workshop//IT\r\nCALSCALE:GREGORIAN\r\nMETHOD:PUBLISH\r\n${body}\r\nEND:VCALENDAR`;
  const url = URL.createObjectURL(new Blob([ics], { type: "text/calendar;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = "workshop-natural-anti-age.ics";
  a.click();
  URL.revokeObjectURL(url);
}
